export default __webpack_public_path__ + "static/media/cal-patch.564507e1.jpg";